import { createFileRoute } from "@tanstack/react-router";
import { Read } from "../../app/views/trikin/read";

export const Route = createFileRoute("/trikin/read")({
  component: Read,
});
